import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XIcon, FlipHorizontalIcon, ZapIcon, ClockIcon, Wand2Icon, CheckIcon } from 'lucide-react';
export function Record() {
  const navigate = useNavigate();
  const [isRecording, setIsRecording] = useState(false);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isRecording) {
      interval = setInterval(() => {
        setProgress(p => {
          if (p >= 100) {
            setIsRecording(false);
            return 100;
          }
          return p + 1;
        });
      }, 150); // 15 seconds total
    }
    return () => clearInterval(interval);
  }, [isRecording]);
  const handleComplete = () => {
    navigate('/upload/preview');
  };
  return <div className="w-full h-full bg-black relative overflow-hidden" data-id="element-738">
      {/* Mock Camera Viewfinder */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-800 to-slate-900" data-id="element-739">
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'radial-gradient(circle at center, white 1px, transparent 1px)',
        backgroundSize: '20px 20px'
      }} data-id="element-740" />
      </div>

      {/* Top Bar */}
      <div className="absolute top-0 left-0 right-0 p-6 flex justify-between items-start z-10" data-id="element-741">
        <button onClick={() => navigate(-1)} className="text-white drop-shadow-md" data-id="element-742">
          <XIcon size={28} data-id="element-743" />
        </button>

        {/* Progress Bar */}
        <div className="absolute top-2 left-1/2 -translate-x-1/2 w-1/2 h-1.5 bg-white/20 rounded-full overflow-hidden" data-id="element-744">
          <motion.div className="h-full bg-primary" style={{
          width: `${progress}%`
        }} data-id="element-745" />
        </div>
      </div>

      {/* Right Tools Rail */}
      <div className="absolute right-4 top-20 flex flex-col gap-6 z-10" data-id="element-746">
        {[{
        icon: FlipHorizontalIcon,
        label: 'Flip'
      }, {
        icon: ZapIcon,
        label: 'Flash'
      }, {
        icon: ClockIcon,
        label: 'Timer'
      }, {
        icon: Wand2Icon,
        label: 'Beauty'
      }].map((tool, i) => <button key={i} className="flex flex-col items-center gap-1 text-white drop-shadow-md" data-id="element-747">
            <tool.icon size={24} data-id="element-748" />
            <span className="text-[10px] font-medium" data-id="element-749">{tool.label}</span>
          </button>)}
      </div>

      {/* Bottom Controls */}
      <div className="absolute bottom-0 left-0 right-0 pb-12 pt-20 bg-gradient-to-t from-black/80 to-transparent flex flex-col items-center z-10" data-id="element-750">
        <div className="flex items-center justify-center w-full relative" data-id="element-751">
          {/* Gallery Thumbnail */}
          <div className="absolute left-8 w-10 h-10 rounded-lg bg-surface border border-border overflow-hidden" data-id="element-752">
            <div className="w-full h-full bg-gradient-to-br from-purple-500 to-blue-500" data-id="element-753" />
          </div>

          {/* Record Button */}
          <button onClick={() => setIsRecording(!isRecording)} className="relative w-20 h-20 flex items-center justify-center" data-id="element-754">
            <div className={`absolute inset-0 rounded-full border-4 transition-colors ${isRecording ? 'border-neonOrange' : 'border-primary'}`} data-id="element-755" />
            <motion.div animate={{
            scale: isRecording ? 0.5 : 1,
            borderRadius: isRecording ? '8px' : '50%'
          }} className={`w-16 h-16 ${isRecording ? 'bg-neonOrange' : 'bg-primary'}`} data-id="element-756" />
          </button>

          {/* Next Button (Shows when there's progress) */}
          {progress > 0 && !isRecording && <motion.button initial={{
          scale: 0,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} onClick={handleComplete} className="absolute right-8 w-10 h-10 bg-primary rounded-full flex items-center justify-center text-[#121212]" data-id="element-757">
              <CheckIcon size={20} strokeWidth={3} data-id="element-758" />
            </motion.button>}
        </div>
      </div>
    </div>;
}